// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import {Loading ,MessageBox } from 'element-ui';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css';
import IScrollView from 'vue-iscroll-view'
import IScroll from 'iscroll'
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import Utils from './utils'
import axios from "axios"
import Vueaxios from "vue-axios"
import dateTime from 'vue-date-time-m';
/* eslint-disable no-new */
Vue.use(dateTime)
Vue.use(ElementUI)
Vue.use(VueVideoPlayer)
Vue.use(IScrollView, IScroll)
Vue.use(VueAwesomeSwiper)
Vue.use(Vueaxios , axios )
let loadingInstance='';

//a request interceptor
axios.interceptors.request.use(function (config) {
  const token = Utils.token.get() || '';
  if (config.url != '/api/Index/Article' && config.url != '/api/Index/Category'  && config.url != '/api/Course/Times'
  && config.url != '/api/Index/Roll' && config.url != '/api/Course/Details'
  && config.url != '/api/Course/Chapter') {
    loadingInstance = Loading.service({ fullscreen: true ,background:'rgba(0, 0, 0, 0.6)'});
  }
  if (token != '' && token != undefined && token != null && token != 'undefined' && token != 'null') {
    config.headers.auth = token;
  }
  return config;
}, function (err) {
  return Promise.reject(err);
});
axios.interceptors.response.use(function (response) {
  if (response.config.url !== '/api/Course/Times' && response.config.url !== '/api/Course/Chapter'&& response.config.url !== '/api/Course/Details'
  ) {
    setTimeout(()=>{
      loadingInstance.close();
    },500)
  }
  if(response.data.code === 501){
    MessageBox.confirm('<div class="bgIconAlert"><i class="el-icon-warning"></i><div>'+response.data.msg+'</div></div>', '', {
      dangerouslyUseHTMLString: true,
      confirmButtonText: '关闭',
      center: true
    }).then(()=>{
      router.push({name: 'EnrollView'})
    })
  }else if (response.data.code === 500) {
    MessageBox.confirm('<div class="bgIconAlert"><i class="el-icon-warning"></i><div>'+response.data.msg+'</div></div>', '', {
      dangerouslyUseHTMLString: true,
      confirmButtonText: '关闭',
      center: true
    }).then(()=>{
      
    })
  }else if (response.data.code === 502) {
    MessageBox.confirm('<div class="bgIconAlert"><i class="el-icon-warning"></i><div>'+response.data.res.msg+'</div></div>', '', {
      dangerouslyUseHTMLString: true,
      confirmButtonText: '关闭',
      center: true
    }).then(()=>{
      router.push({name: 'Index'})
    })
  } else if (response.data.code === 504) {
    MessageBox.confirm('<div class="bgIconAlert"><i class="el-icon-warning"></i><div>'+response.data.res.msg+'</div></div>', '', {
      dangerouslyUseHTMLString: true,
      confirmButtonText: '关闭',
      center: true
    }).then(()=>{
      router.push({name: 'Index'})
    })
  }else if (response.data.code === 401) {
    var urlRouter = response.request.responseURL.split('/api/')[1]
    if (urlRouter !== 'SignUp/GetCardID'){
      MessageBox.confirm('<div class="bgIconAlert"><i class="el-icon-warning"></i><div>'+response.data.msg+'</div></div>', '', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '关闭',
        center: true
      }).then(()=>{
        window.localStorage.clear();
        router.push({name: 'Index'})
      })
    }
  }
  return response;
}, function (error) {
return Promise.reject(error);
});

Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js